import apidivergenciasdocumentosweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apidivergenciasdocumentosweb.get('divergenciasdocumentos', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async findDadosDivergencias(_, { params }) {
      const p = params;
      const [{ data }] = await Promise.all([
        apidivergenciasdocumentosweb.get(`/divergenciasdocumentos/dados/${p.idempresa}/${p.idcliente}/${p.mes}/${p.tipo}`),
      ]);

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
